import React,{useState,useEffect,useLayoutEffect,useRef} from 'react';
import {
    useParams,
    Link, BrowserRouter as Router, Route
} from "react-router-dom";
import Sticky from 'react-sticky-el';
import Header from "./header";
import Footer from "./footer";
import PersonData from "../data/fulldata.json"
import Home from "./home";
import {
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    WhatsappIcon,
    FacebookIcon,
    TwitterIcon
} from "react-share";


export default function Person() {

    const anchor = useRef(null);
    const image = useRef(null);

   // const [data,setData] = useState(null);
    const [isVisible, setIsVisible] = useState(true);


    let { id } = useParams();

    useEffect(()=>{

            window.addEventListener('scroll', handleScrollChange);
            window.addEventListener('resize', handleScrollChange);
            setTimeout(()=>{handleScrollChange()},1000);



    },[]);
    useEffect(()=>{
        handleScrollChange();
        window.scrollTo(0, 0)
    })




    function handleScrollChange(){
        if(anchor?.current){
           //  const doc = document.documentElement;
           //  const top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
           //  const windowHeight = window.innerHeight;
           //  const anchorTop = anchor.current.offsetTop - anchor.current.offsetHeight;
           //  const ElementTop =  (top + windowHeight - (image.current.offsetHeight));
           //
           //  image.current.style.position = 'absolute';
           //
           //  console.log('ElementTop', ElementTop);
           // // const addToTop = image.current.offsetHeight
           //
           //  console.log('top',anchor.current.offsetTop +  image.current.offsetHeight * 0.1);
           //  console.log('windowHeight', top + windowHeight );
           //  //console.log('anchor.current.offsetTop + addToTop', anchor.current.offsetTop + addToTop);
           //  image.current.style.top =  (anchor.current.offsetTop - anchor.current.offsetHeight) + 'px' ;
           //
           //  if(top + windowHeight < anchor.current.offsetTop +  anchor.current.offsetHeight){
           //
           //  }
        }
    }

    // useEffect(()=>{
    //     if(anchor){
    //         // window.addEventListener('scroll', handleScrollChange);
    //         // handleScrollChange();
    //     }
    // })




    return(
        <div className={"inner-page"}>
            <Header inner={true} />
             <main>
                 {PersonData[id] ?
                     <>
                    <div className={"share"}>
                        <FacebookShareButton url={'http://www.ice.co.il/40under40_2020/'+id}>
                            <FacebookIcon size={40} round={true} />
                        </FacebookShareButton>
                        <TwitterShareButton url={'http://www.ice.co.il/40under40_2020/'+id}>
                            <TwitterIcon size={40} round={true} />
                        </TwitterShareButton>
                        <WhatsappShareButton url={'http://www.ice.co.il/40under40_2020/'+id}>
                            <WhatsappIcon size={40} round={true} />
                        </WhatsappShareButton>
                    </div>
                    <h1 className={"inner-page__title"} dangerouslySetInnerHTML={{__html:PersonData[id].title.replace(/\n/g, "<br />")}} />
                    <div className={"inner-page__section1"}>
                        <p dangerouslySetInnerHTML={{__html: PersonData[id].section1.replace(/\n/g, "<br />")}} />
                    </div>
                     <div className={"inner-page__section2"}>
                         <h2 className={"inner-page__title"}>הישגים מרכזיים</h2>
                         <p dangerouslySetInnerHTML={{__html: PersonData[id].section2.replace(/\n/g, "<br />")}} />
                     </div>
                     <div ref={anchor} className={"inner-page__section3"}>
                         <div className={"arrows"}>
                             {id > 1 ? <Link to={'/40under40_2020/'+ (parseInt(id) - 1)} className={"arrows_right"}>הקודם</Link> : ''}
                             {id < 40 ? <Link to={'/40under40_2020/'+ (parseInt(id) + 1)} className={"arrows_left"}>הבא</Link>: ''}
                         </div>
                         <div ref={image} className={"inner-page__image"}>
                             <img onLoad={handleScrollChange} src={require('../assets/images/personalities/'+ PersonData[id].image).default} />
                         </div>
                         <div className={"inner-page__section3__inner"}>
                             <h2>שאלות ותשובות</h2>
                             {PersonData[id].section3.map((item)=>{
                                return (
                                    <>
                                        <h3 dangerouslySetInnerHTML={{__html: item['q'].replace(/\n/g, "<br />")}} />
                                        <p dangerouslySetInnerHTML={{__html: item['a'].replace(/\n/g, "<br />")}} />
                                    </>
                                );
                             })}
                         </div>
                     </div>
                     <div className={"inner-page__section4"}>
                         <h2 className={"inner-page__title"}>טיפים ממך להתפתחות אישית או מקצועית?</h2>
                         <p dangerouslySetInnerHTML={{__html: PersonData[id].section4.replace(/\n/g, "<br />")}} />
                     </div>
                    </>
                 : ''}
                 <section className={"articles"}>
                     <div className={"articles_inner"}>
                     <article>
                         <a href={"http://www.ice.co.il/all-projects/news/article/799904"}><img src={"http://img.ice.co.il/giflib/news/rsPhoto/sz_240/rsz_277_155_4ce2102020.jpg"} /></a>
                         <p><a href={"http://www.ice.co.il/all-projects/news/article/799904"}>"בתקופה שבה כללי המשחק משתנים כמעט מדי יום, חובה לתת ביטוי לגמישות מחשבתית"</a></p>
                     </article>
                     <article>
                         <a href={"http://www.ice.co.il/all-projects/news/article/799750"}><img src={"http://img.ice.co.il/giflib/news/rsPhoto/sz_251/rsz_277_155_8ice21122020.jpg"} /></a>
                         <p><a href={"http://www.ice.co.il/all-projects/news/article/799750"}>"האפליקציה שלנו היא תולדה של מהפכה פיננסית שמנפצת מוסכמות ישנות"</a></p>
                     </article>
                     <article>
                         <a href={""} className={"inarticle-desktop"}><img src={require("../assets/images/bankh-inarticle.jpg").default} /></a>
                         <a href={""} className={"inarticle-mobile"}><img src={require("../assets/images/bankh-inarticle-mobile.jpg").default} /></a>
                     </article>
                     <article>
                         <a className={"inarticle-desktop"} target={"_top"} href={"https://campaign.hot.net.il/triple/dynamic/?utm_source=ice&utm_medium=banner40X40_hot&utm_campaign=campaign_40X40_ice_2020"}><img src={require("../assets/images/hot-inarticle.jpg").default} /></a>
                         <a className={"inarticle-mobile"} target={"_top"} href={"https://campaign.hot.net.il/triple/dynamic/?utm_source=ice&utm_medium=banner40X40_hot&utm_campaign=campaign_40X40_ice_2020"}><img src={require("../assets/images/hot-inarticle-mobile.jpg").default} /></a>
                     </article>
                         {id == 6 ?
                             <>
                                 <article>
                                     <Link to={"/40under40_2020/26"}><img
                                         src={"http://img.ice.co.il/giflib/news/rsPhoto/sz_249/rsz_277_155_11ice4122020.jpg"}/></Link>
                                     <p><Link to={"/40under40_2020/26"}>התחלתי כמחלק פלאיירים": מנכ"ל סלופארק מספר על הדרך בה החלום התממש בכיוון לא צפוי</Link></p>
                                 </article>
                             </>
                             :
                             <>
                             <article>
                                 <Link to={"/40under40_2020/6"}><img
                                     src={"http://img.ice.co.il/giflib/news/rsPhoto/sz_249/rsz_277_155_5ice4122020.jpg"}/></Link>
                                 <p><Link to={"/40under40_2020/6"}>"לא לחשוש לצאת מאזור הנוחות": מנכ"ל KAPE משתף בעצות
                                     שיקפיצו לכם את הקריירה</Link></p>
                             </article>
                             </>
                         }
                         {id == 7 ?
                              <>
                             <article>
                                <Link to={"/40under40_2020/9"}><img src={"http://img.ice.co.il/giflib/news/rsPhoto/sz_250/rsz_277_155_9ice15122020.jpg"} /></Link>
                                <p><Link to={"/40under40_2020/9"}>סוחר במניות מגיל 13 - הדרך להצלחה של מייסד eToro</Link></p>
                             </article>
                             </>
                             :
                             <>
                             <article>
                                 <Link to={"/40under40_2020/7"}><img src={"http://img.ice.co.il/giflib/news/rsPhoto/sz_250/rsz_277_155_15ice14122020.jpg"} /></Link>
                                 <p><Link to={"/40under40_2020/7"}>"לבוא טאבולה ראסה": בכירה בקרן ההשקעות קטליסט משתפת בעצות להתפתחות מקצועית</Link></p>
                             </article>
                             </>
                         }
                     </div>
                 </section>
             </main>
            <Footer/>

        </div>
    );
}